import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DownloadURL, MmRequestDownloadFilesBulkRequest, MmRequestResponse } from '@models/products-and-orders/requests';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class MmRequestsService {
  private readonly url = `${environment.bffUrl}/mm-requests`;

  constructor(private httpClient: HttpClient) {}

  getOne(id: string): Observable<MmRequestResponse> {
    return this.httpClient.get<MmRequestResponse>(`${this.url}/${id}`);
  }

  getDownloadUrl(id: string, fileId: string): Observable<DownloadURL> {
    return this.httpClient.get<DownloadURL>(`${this.url}/${id}/files/${fileId}/download-url`);
  }

  getDownloadUrlBulk(id: string, data: MmRequestDownloadFilesBulkRequest): Observable<DownloadURL> {
    return this.httpClient.post<DownloadURL>(`${this.url}/${id}/files/download-bulk`, data);
  }
}
